import { Vue, Component, Prop, Provide, Watch } from "vue-property-decorator";
import i18n from "@/i18n";


import { PageModel } from "@/data/page/page.model";

import { State, Getter, Action, Mutation } from "vuex-class";

@Component({
	name: "HomePage"
})

export default class HomePage extends Vue {
	@Getter("i18n/getCurrentLang") private currentLang!: string;
	@Getter("i18n/hasInitialized") private i18nHasInitialized!: boolean;

	@Mutation("state/setLoading") private setLoading!: any;

	private content: any = null;
	private contentIsReady: boolean = false;
	private url: string = window.location.href;

	private created() {
		if (this.$route.query.view) {
			this.$router.push({ query: { view: undefined } })
		}
	}

	private mounted() {
		this.getContent();
	}

	@Watch("currentLang")
	@Watch("i18nHasInitialized")
	private async getContent() {
		if (this.i18nHasInitialized) {
			this.setLoading(false);
			this.content = await new PageModel().getTemplatePage({ slug: "pages/home_page.php", related_recursive_calls: 2 });
			this.contentIsReady = true;
			console.log("Home Page content ->", this.content)
		}
	}
}
